import { IProjectGetAllRPC, IProjectGetRPC } from "@prisma/studio-common";
import { IServerOptions } from "../StudioServer";

interface ProjectChannelOptions {
  schemaPath: IServerOptions["schemaPath"];
}

export class ProjectChannel {
  private name: string;
  private schemaPath: string;

  constructor(options: ProjectChannelOptions) {
    this.name = "Prisma Studio";
    this.schemaPath = options.schemaPath;
  }

  respond(
    req: IProjectGetRPC["request"] | IProjectGetAllRPC["request"]
  ): Promise<IProjectGetRPC["response"] | IProjectGetAllRPC["response"]> {
    const res: IProjectGetRPC["response"] | IProjectGetAllRPC["response"] = {
      requestId: req.requestId,
      channel: `-${req.channel}`,
      action: req.action,
      payload: {
        error: null,
        data: null,
      },
    };

    switch (req.action) {
      case "get":
        res.payload.data = {
          name: this.name,
          schemaPath: this.schemaPath,
          lastOpenedAt: new Date().toISOString(),
        };
        break;
      case "getAll":
        res.payload.data = [
          {
            name: this.name,
            schemaPath: this.schemaPath,
            lastOpenedAt: new Date().toISOString(),
          },
        ];
        break;
    }

    return Promise.resolve(res);
  }
}
